export default __webpack_public_path__ + "static/media/icon-arrow-forward.12d29d5b.svg";